import React from 'react'

export default function ContactHead({quoteHead}) {
  return (
    <>
    <section className="contactpage-head">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <p>{quoteHead.desc}</p>
                    <span>{quoteHead.title}</span>
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
